import {Customer} from "../customer";
import {Contact} from "../contact";
import {Address} from "../address";
import {Nullable} from "../../../../types";

export enum ShipmentField {
    ID = "id",
    SHIPMENT_NUMBER = "shipmentNumber",
    ORDER_NUMBER = "orderNumber",
    REFERENCE = "reference",
    CREATED_AT = "createdAt",
    UPDATED_AT = "updatedAt",
    CONFIRMED_AT = "confirmedAt",
    SHIPPED_AT = "shippedAt",
    DELIVERED_AT = "deliveredAt",
    RECEIVER = "receiver",
    DELIVERY_REFERENCE = "deliveryReference",
    SHIPPING_INFO = "shippingInfo",
    CUSTOMER = "customer",
    CUSTOMER_NAME = "customerName",
    SHIPPING_RECIPIENT = "shippingRecipient",
    DEVICES = "devices",
    ACCESSORIES = "accessories",
    SERIAL_NUMBERS = "serialNumbers",
    SIMICCIDS = "simiccids",
    STATUS = "status",
    CANCELED_AT = "canceledAt",
    CANCEL_REASON = "cancelReason",
}

export interface Shipment {
    [ShipmentField.ID]: number;
    [ShipmentField.SHIPMENT_NUMBER]: string;
    [ShipmentField.ORDER_NUMBER]: string;
    [ShipmentField.REFERENCE]?: string;
    [ShipmentField.CREATED_AT]: string;
    [ShipmentField.UPDATED_AT]: string;
    [ShipmentField.CONFIRMED_AT]?: string;
    [ShipmentField.SHIPPED_AT]?: string;
    [ShipmentField.DELIVERED_AT]?: string;
    [ShipmentField.RECEIVER]?: string;
    [ShipmentField.DELIVERY_REFERENCE]?: string;
    [ShipmentField.SHIPPING_INFO]: ShippingInfo;
    [ShipmentField.CUSTOMER]?: Customer;
    [ShipmentField.SHIPPING_RECIPIENT]: ShippingRecipient;
    [ShipmentField.DEVICES]: ShipmentDevice[];
    [ShipmentField.ACCESSORIES]: Accessory[];
    [ShipmentField.SERIAL_NUMBERS]?: ItemSerialNumber[];
    [ShipmentField.SIMICCIDS]?: string[];
    [ShipmentField.STATUS]: ShipmentStatus;
    [ShipmentField.CANCELED_AT]: Nullable<string>;
    [ShipmentField.CANCEL_REASON]: Nullable<string>;
}

export interface ShipmentFlat
    extends Pick<
        Shipment,
        | ShipmentField.ID
        | ShipmentField.SHIPMENT_NUMBER
        | ShipmentField.ORDER_NUMBER
        | ShipmentField.CREATED_AT
        | ShipmentField.UPDATED_AT
        | ShipmentField.CONFIRMED_AT
        | ShipmentField.SHIPPED_AT
        | ShipmentField.DELIVERED_AT
        | ShipmentField.CANCELED_AT
        | ShipmentField.STATUS
    > {
    [ShipmentField.CUSTOMER_NAME]: string;
}

export enum ShippingRecipientField {
    COMPANY_NAME = "companyName",
    CONTACT = "contact",
    ADDRESS = "address",
}

export interface ShippingRecipient {
    [ShippingRecipientField.COMPANY_NAME]: string;
    [ShippingRecipientField.CONTACT]: Contact;
    [ShippingRecipientField.ADDRESS]: Address;
}

export enum ShipmentStatus {
    NEW = "NEW",
    CANCELED = "CANCELED",
    CONFIRMED = "CONFIRMED",
    DELIVERED = "DELIVERED",
    SHIPMENT_CREATED = "SHIPMENT_CREATED",
    SHIPPED = "SHIPPED",
}

export enum ItemSerialNumberField {
    LEO_ID = "leoId",
    SERIAL_NUMBER = "serialNumber",
}

export interface ItemSerialNumber {
    [ItemSerialNumberField.LEO_ID]: string;
    [ItemSerialNumberField.SERIAL_NUMBER]: string;
}

export enum ShippingInfoField {
    TRACKING_NUMBER = "trackingNumber",
    SHIPPER = "shipper",
    SHIPPING_TIME = "shippingTime",
}

export interface ShippingInfo {
    [ShippingInfoField.TRACKING_NUMBER]?: string;
    [ShippingInfoField.SHIPPER]?: string;
    [ShippingInfoField.SHIPPING_TIME]?: string;
}

export enum ShipmentDeviceField {
    TYPE = "type",
    QUANTITY = "quantity",
}

export interface ShipmentDevice {
    [ShipmentDeviceField.TYPE]: string;
    [ShipmentDeviceField.QUANTITY]: number;
}

export enum AccessoryField {
    ARTICLE = "article",
    QUANTITY = "quantity",
}

export interface Accessory {
    [AccessoryField.ARTICLE]: string;
    [AccessoryField.QUANTITY]: number;
}
